import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const CookieConsent = ({ isDarkMode }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('cookieConsent', 'dismissed');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-4 pointer-events-none">
      <div className={`max-w-md mx-auto pointer-events-auto neumorphic-card rounded-xl ${
        isDarkMode ? 'bg-velvet/95 dark:bg-velvet' : 'bg-cream/95'
      } backdrop-blur-sm animate-slideInUp`}>
        <div className="flex items-start justify-between mb-4">
          <h3 className="font-serif font-semibold text-sapphire dark:text-cream-light pr-4">
            Privacy & Cookies
          </h3>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-sapphire dark:hover:text-gold transition-colors flex-shrink-0"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
          We use cookies to improve your experience and personalize content. By continuing, you agree to our use of cookies and data practices.
        </p>

        <div className="flex gap-3">
          <Button
            onClick={handleAccept}
            className="flex-1 btn-gold text-sm font-semibold"
          >
            Accept All
          </Button>
          <Button
            onClick={handleDismiss}
            variant="outline"
            className="flex-1 border-sapphire dark:border-gold text-sapphire dark:text-gold hover:bg-sapphire hover:text-cream dark:hover:bg-gold dark:hover:text-velvet text-sm font-semibold"
          >
            Manage
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
